<div class="space-x-2 p-0.5 flex flex-nowrap items-center min-w-0">
  <span (dblclick)="copyDesignName()" pTooltip="Double-click to copy name" tooltipPosition="bottom" class="pr-2 pl-2 pt-1 text-xs truncate min-w-0 shrink">
    <span class="hidden lg:inline">Design: </span>{{ design()?.name }}
  </span>

  @if (user()?.roles?.readOnly) {
    <span class="text-sm text-red-500 pt-0.5">[read-only]</span>
  }

  @if (isTubularReady()) {
    <app-units-select-input
      class="min-w-0 shrink"
      placeholder="&#60;Well Configuration: Empty>"
      [unit]="shortLengthUnit()"
      [unitPrecisionOverrides]="pipeDimensionPrecisionOverrides()"
      [options]="tubulars()"
      [ngModel]="selectedTubular()?.id"
      optionValue="id"
      [optionLabelFormatter]="formatTubularOption"
      (ngModelChange)="onTubularSelectionChange($event)"
      ariaLabel="Well configuration"
      appendTo="body">
    </app-units-select-input>
  }

  <div class="flex flex-shrink-0">
    <p-button [outlined]="true" title="Calculate PERICAL - Thermal" size="small" styleClass="perical" class="pl-1 calc-btns"
      (onClick)="calculateThermal.emit()" [disabled]="isPericalDisabled()" [loading]="calculatingPerical()">
      @if (!calculatingPerical()) {
        <img [ngClass]="'perical-icon'" class="img" src="../../assets/icons/icons8-fire-90.png" />
      }
      <span [style.color]="!isDarkMode() ? 'black' : ''" class="pr-2 text-xs hidden lg:inline">PERICAL</span>
    </p-button>

    <p-button [outlined]="true" title="Calculate PERINIX - APB" size="small" styleClass="perinix" class="pl-1 calc-btns"
      (onClick)="calculateApb.emit()" [disabled]="isPerinixDisabled()" [loading]="calculatingPerinix()">
      @if (!calculatingPerinix()) {
        <img [ngClass]="'perinix-icon'" class="img" src="../../assets/icons/icons8-pressure-100.png" />
      }
      <span [style.color]="!isDarkMode() ? 'black' : ''" class="pr-2 text-xs hidden lg:inline">PERINIX</span>
    </p-button>

    <p-button [outlined]="true" title="Calculate PERIVIS - Stress" size="small" styleClass="perivis" class="pl-1 calc-btns"
      (onClick)="calculateStress.emit()" [disabled]="isPerivisDisabled()" [loading]="calculatingPerivis()">
      @if (!calculatingPerivis()) {
        <img [ngClass]="'perivis-icon'" class="img" src="../../assets/icons/icons8-sigma-96.png" />
      }
      <span [style.color]="!isDarkMode() ? 'black' : ''" class="pr-2 text-xs hidden lg:inline">PERIVIS</span>
    </p-button>
  </div>
</div>
